<!-- 专家服务信息 -->
<template>
<div class="info-block">
  <router-link :to="'/jrkjfw/zjfwDetail/'+info.id" class="info-block-a">
    <div class="div-1">
      <div class="div-1-1">{{info.name}}<span>{{info.professional_title}}</span></div>
      <div class="div-1-2">研究方向<span>{{info.major_field}}</span>从事专业<span>{{info.skilled_field}}</span></div>
      <div class="div-1-3">{{info.introduction.replace(/<[^>]*>/g,'').replace(/&nbsp;/ig,'').substring(0,140)+'...'}}</div>
      <div class="div-1-4">
        <a class="td-action-1">在线预约</a>
        预约费用：<span>￥100.00</span>
      </div>
      <div class="div-1-5"  v-bind:style="{backgroundImage:'url('+info.cover_img+')'}">
      </div>
    </div>

  </router-link>
</div>
</template>

<script>
export default {
  name: 'ZyhzsInfo1',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:160px;
  padding:10px 0px 10px 0px;
  margin:0px 1px 20px 0px;
  //background-color: #F6F8F9;
  //background-color: red;
  border-bottom:1px dashed #707070;
  background-size: 160px auto;
  background-repeat: no-repeat;
  background-position: 0px 10px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border-bottom:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:160px;
  width:100%;
  padding:0px 150px 0px 160px;
  //background:red;
}

.div-1-1{
  position:relative;
  height:30px;
  //background:red;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#515151;
  padding:2px 10px 10px 0px;
}

.div-1-1 span{
  color:#fff;
  background: var(--color1);
  padding:2px 5px 2px 5px;
  margin-left:10px;
}

.div-1-2{
  position:relative;
  height:40px;
  //background:red;
  font-size:12px;
  line-height:40px;
  text-align:left;
  color:#515151;
  padding:0px;
}

.div-1-2 span{
  color:var(--color6);
  padding:0px 10px 0px 10px;
}

.div-1-3{
  position:relative;
  //background:red;
  font-size:12px;
  text-align:left;
  font-weight:500;
  color:#bbb;
  line-height:20px;
  padding:0px 10px 5px 0px;
}

.div-1-4{
  position:absolute;
  top:0px;
  right:0px;
  width:150px;
  margin:0px;
  padding-left:10px;
  font-size:14px;
  line-height:30px;
  //background:yellow;
}

.div-1-4 span{
  font-size:14px;
  font-weight:600;
  color: var(--color2);
}

.div-1-4 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:30px;
  border:0px solid #000;
  background:var(--color1);
  color:#fff;
  line-height:20px;
  text-align:center;
}

.div-1-5{
  position:absolute;
  top:0px;
  left:0px;
  width:140px;
  height:160px;
  margin:0px;
  //background:yellow;
  background-size: auto 160px;
  background-repeat: no-repeat;
  background-position: center 0;
}

.div-2{
  position:relative;
  height:20%;
  width:100%;
  padding:0px 10px 0px 230px;
  color:#515151;
  //background:#fff;
}

.div-3{
  position:relative;
  height:30%;
  width:100%;
  padding:0px 10px 0px 230px;
  color:#8a8a8a;
  //background:#fff;
}


.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/ZjInfo1.vue